import { fromEnumAsString } from '../../../serialization/enum-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/dto.js';
import { LegacyOrderHook, LegacyOrderHookId } from '../legacy-order-hook.js';
import { OrderSideEffectType } from './order-side-effect-type.js';
import { OrderSideEffect } from './order-side-effect.js';

export class DeferOrderCompletionSideEffect extends OrderSideEffect {
  static readonly TYPE_ID: string = '600a9930cdae4ee0a02bb51519f0ba24';

  public readonly effectType: OrderSideEffectType = OrderSideEffectType.DeferOrderCompletion;

  private constructor() {
    super();
  }

  get $typeId(): string {
    return DeferOrderCompletionSideEffect.TYPE_ID;
  }

  static create(): DeferOrderCompletionSideEffect {
    return new DeferOrderCompletionSideEffect();
  }

  static fromMap(context: SerializationContext, map: SerializedData): DeferOrderCompletionSideEffect {
    return new DeferOrderCompletionSideEffect();
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'effectType': fromEnumAsString(this.effectType),
    };
  }

  clone(): this {
    return new DeferOrderCompletionSideEffect() as this;
  }

  isSame(other: DeferOrderCompletionSideEffect): boolean {
    if(this === other) {
      return true;
    }

    return other.effectType === this.effectType;
  }

  toLegacyOrderHook(): LegacyOrderHook {
    return LegacyOrderHook.create(LegacyOrderHookId.DeferOrderCompletion);
  }

  static verifyType(order: DataModel): boolean {
    return order instanceof DeferOrderCompletionSideEffect;
  }

  static assertType(order: DataModel): order is DeferOrderCompletionSideEffect {
    return order instanceof DeferOrderCompletionSideEffect;
  }
}

export class DeferOrderCompletionSideEffectBuilder extends DataModelBuilder<DeferOrderCompletionSideEffect> {
  build(context: SerializationContext, map: SerializedData): DeferOrderCompletionSideEffect {
    return DeferOrderCompletionSideEffect.fromMap(context, map);
  }
}
